import { Component, Input } from '@angular/core';
import { EntitlementService } from '@app/@shared/services/entitlement/entitlement.service';

@Component({
    selector: 'app-non-entitled-prompt',
    templateUrl: './non-entitled-prompt.component.html',
    styleUrls: ['./non-entitled-prompt.component.scss'],
    standalone: false
})
export class NonEntitledPromptComponent {
  @Input() channelNames: string;
  @Input() subscriptionId: string;
  @Input() requestAccessDialogString: string;

  constructor(
    private entitlementService: EntitlementService,
  ) {}

  onClickRequest() {
      this.entitlementService.openRequestAccessFormDialog(this.requestAccessDialogString);
  }
}
